const data = {
  game: 'words',
  words: [
    {
      id: 0,
      idDisordered: 3,
      text: 'I',
      textDisordered: 'teeth.',
    },
    {
      id: 1,
      idDisordered: 1,
      text: 'brush',
      textDisordered: 'brush',
    },
    {
      id: 2,
      idDisordered: 2,
      text: 'my',
      textDisordered: 'my',
    },
    {
      id: 3,
      idDisordered: 0,
      text: 'teeth.',
      textDisordered: 'I',
    },
  ],
};

export default data;
